import { zodStringNullable } from '@qapline/helpers';
import { z } from 'zod';

export const rampSchema = z.object({
    ramp_id: z.number(),
    number: z.string(),
    gatehousePhone: zodStringNullable(),
    location_id: z.number(),
    deleted: z.boolean(),
});

export type TRamp = z.infer<typeof rampSchema>;
